<template>
  <div>
    <table class="table">
      <thead>
        <th
          v-for="attendance in attendances"
          :key="attendance.attendanceDate"
          :class="{ 'red--text': isHoliday(attendance) }"
        >
          <v-tooltip
            bottom
            color="red"
            :disabled="!attendance.holidayChinName"
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                {{ dayOfWeek(attendance.attendanceDate) }}
                <br>
                {{ momentWithHyphen(attendance.attendanceDate).format('DD/MM') }}
              </div>
            </template>
            <span>{{ $chPtObjData('holidayChinName', attendance) }}</span>
          </v-tooltip>
        </th>
      </thead>
      <tbody>
        <tr>
          <td
            v-for="attendance in attendances"
            :key="attendance.attendanceDate"
            style="border-bottom: none;"
          >
            <s-attendance-time
              :daily-times="attendance.listStaffAttendance"
            />
            <!--
            <div
              v-for="leaveReason in attendance.leaves"
              :key="leaveReason"
            >
              <v-chip
                color="orange"
                small
                class="mb-1"
              >
                {{ leaveReason }}
              </v-chip>
            </div>
            -->
            <v-tooltip
              v-for="leaveReason in attendance.leaves"
              :key="leaveReason.startTime"
              bottom
              open-on-click
              color="grey darken-4"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="orange darken-1"
                  small
                  class="mb-1 mr-1"
                  dark
                  v-on="on"
                >
                  {{ leaveReason.code }}
                </v-chip>
              </template>
              <span>
                {{ leaveReason.desc }}
                <template v-if="leaveReason.hasTime">
                  {{ momentWithHyphen(leaveReason.startTime).format('HH:mm') }} ~ {{ momentWithHyphen(leaveReason.endTime).format('HH:mm') }}
                </template>
                <template v-else>
                  ({{ $t('PublicServant.AbsentSupplementary.Detail.WholeDay') }})
                </template>
              </span>
            </v-tooltip>
          </td>
        </tr>
        <tr>
          <td
            v-for="attendance in attendances"
            :key="attendance.attendanceDate"
            style="border-top: none;"
          >
            <div class="mx-1 text-body-2">
              {{ attendance.obser }}
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td
            v-for="attendance in attendances"
            :key="attendance.attendanceDate"
          >
            {{ secondToHourMinute(attendance.dailySettlementAmount) }}
          </td>
        </tr> -->
        <!-- <tr>
          <td colspan="7">
            {{ $t('Attendance.OnlineAdjustWorkingHour') }}*
          </td>
        </tr> -->
        <tr>
          <td
            v-for="attendance in attendances"
            :key="attendance.attendanceDate"
            class="red--text text--darken-2 font-weight-bold"
          >
            {{ secondToHourMinute(attendance.adjustmentDailySettlementAmount) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  .table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
  }

  .table th,
  .table td {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .table th {
    border-left: none;
    border-right: none;
  }

  .table td {
    text-align: center;
    vertical-align: top;
    border: 1px solid #ddd;
  }
</style>

<script>

// props format
// attendance
// attendances: [
//   {
//     date: '2019-12-15',
//      dailyAttendances: [
//       {
//         time: '09:00',
//         type: 'A'
//      },
//      {
//        time: '13:00',
//        type: 'D'
//      },
//      {
//        time: '14:30',
//        type: null
//      }, {
//         time: '17:45',
//        type: null
//      }],
//     timeBeforeAdj: '00h 00m',
//     timeAfterAdj: '00h 00m'
//   },
//   {
//     date: '2019-12-16',
//     dailyAttendances: ['09:00', '13:00', '14:30', '17:45'],
//     timeBeforeAdj: '07h 15m',
//     timeAfterAdj: '07h 15m'
//   }
// ]

import { momentWithHyphen } from '@/utils/datetimeUtil'
import SAttendanceTime from './SAttendanceTime'
import { attendanceTableMixin } from '../mixins/attendanceTableMixin'

export default {
  components: {
    SAttendanceTime
  },
  // attendanceWithLeaves come from this mixin
  mixins: [attendanceTableMixin],

  // props: {
  //   attendances: {
  //     type: Array,
  //     default: null
  //   },
  //   leaves: {
  //     type: Array,
  //     default: null
  //   }
  // },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
